import React from "react";

const NotFound = () => {
  return <>hello from not found man</>;
};

export default NotFound;
